import {twMerge} from '@sdox/utils'

import type {ClassNameValue} from 'tailwind-merge'

export interface ScrimProps {
  className?: ClassNameValue
}

export const Scrim = ({className}: ScrimProps) => (
  <div
    className={twMerge(
      'absolute z-20 size-full',
      // We need to transition the background color instead of the opacity because of rendering in chrome.
      // In chrome the edges of the elements in the bottom of the grid in the Gallery component will spill over the
      //  border radius while the transition is running.
      'bg-scrim-primary/0 mix-blend-multiply group-hover:bg-scrim-primary/[.12] group-active:bg-scrim-primary/[.12]',
      'transition duration-300',
      className,
    )}
  />
)
